var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content-spacer", attrs: { id: "links" } }, [
    _c("div", { attrs: { id: "actions" } }, [
      _vm.landingPageLabel1 !== null
        ? _c(
            "button",
            {
              staticClass: "button-secondary",
              on: {
                click: function ($event) {
                  return _vm.openLink(_vm.landingPageLink1)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.landingPageLabel1) + " ")]
          )
        : _vm._e(),
      _vm.landingPageLabel2 !== null
        ? _c(
            "button",
            {
              staticClass: "button-secondary",
              on: {
                click: function ($event) {
                  return _vm.openLink(_vm.landingPageLink2)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.landingPageLabel2) + " ")]
          )
        : _vm._e(),
      _vm.landingPageLabel3 !== null
        ? _c(
            "button",
            {
              staticClass: "button-secondary",
              on: {
                click: function ($event) {
                  return _vm.openLink(_vm.landingPageLink3)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.landingPageLabel3) + " ")]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }